(() => {
  'use strict';
  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: T.currency, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: cents % 100 ? 2 : 0
      }).format(cents / 100) + ' ' + T.currency;
    } catch (e) { return (cents / 100).toFixed(2); }
  };

  /* ---------- header: menu + search ---------- */
  const toggle = (btn, panel, open) => {
    if (!btn || !panel) return;
    const show = open ?? panel.hidden;
    panel.hidden = !show;
    btn.setAttribute('aria-expanded', String(show));
    if (show) { const i = $('input', panel); i && i.focus(); }
  };

  /* ---------- cart drawer ---------- */
  const drawer = () => $('[data-drawer]');
  const openDrawer = () => {
    const d = drawer(); if (!d) return;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    const p = $('.drawer__panel', d); p && p.focus();
  };
  const closeDrawer = () => {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(() => { d.hidden = true; }, 350);
  };
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !Number(n); });
  const refreshDrawer = async () => {
    const res = await fetch(`${T.routes.cart}?section_id=cart-drawer`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = $('[data-drawer-content]', doc);
    const cur = $('[data-drawer-content]');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      const c = $('[data-count-value]', cur); c && setCount(c.textContent);
    }
  };

  /* ---------- product: variants, gallery, add to cart ---------- */
  const initProduct = (root) => {
    const json = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!json || !form) return;
    const product = JSON.parse(json.textContent);
    const idInput = $('[name=id]', form);
    const btn = $('[data-add]', form);
    const price = $('[data-price]', root);

    const showSlide = (id) => {
      $$('[data-slide]', root).forEach((s) => { s.hidden = s.dataset.mediaId !== String(id); });
      $$('[data-thumb]', root).forEach((t) => t.setAttribute('aria-current', String(t.dataset.mediaId === String(id))));
    };
    const slides = $$('[data-slide]', root);
    const lb = $('[data-lightbox]', root), lbImg = $('[data-lightbox-img]', root);
    const current = () => Math.max(0, slides.findIndex((x) => !x.hidden));
    const syncLightbox = () => {
      const img = $('img', slides[current()]); if (!img || !lbImg) return;
      lbImg.src = img.dataset.zoom || img.currentSrc || img.src; lbImg.alt = img.alt;
    };
    const go = (d) => {
      if (slides.length < 2) return;
      const n = (current() + d + slides.length) % slides.length;
      showSlide(slides[n].dataset.mediaId);
      const th = $(`[data-thumb][data-media-id="${slides[n].dataset.mediaId}"]`, root);
      th && th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (lb && !lb.hidden) syncLightbox();
    };
    const closeLightbox = () => { if (!lb || lb.hidden) return; lb.hidden = true; document.body.classList.remove('no-scroll'); };
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-thumb]'); if (t) showSlide(t.dataset.mediaId);
      const s = e.target.closest('[data-qty-step]');
      if (s) { const q = $('[name=quantity]', form); q.value = Math.max(1, (+q.value || 1) + +s.dataset.qtyStep); }
      if (e.target.closest('[data-zoom-open]') && lb) { syncLightbox(); lb.hidden = false; document.body.classList.add('no-scroll'); }
      if (e.target.closest('[data-lightbox-close]') || e.target === lb) closeLightbox();
      const st = e.target.closest('[data-slide-step]'); if (st) go(+st.dataset.slideStep);
    });
    document.addEventListener('keydown', (e) => {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    const main = $('[data-gallery-main]', root);
    if (main) {
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    const update = () => {
      const chosen = $$('[data-option-group]', form).map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      const v = product.variants.find((x) => chosen.every((o, i) => x.options[i] === o));
      if (!btn) return;
      if (!v) { btn.disabled = true; btn.textContent = T.strings.unavailable; return; }
      idInput.value = v.id;
      history.replaceState(null, '', `?variant=${v.id}`);
      if (price) price.innerHTML = (v.compare_at_price > v.price ? `<s class="price__was">${money(v.compare_at_price)}</s> ` : '') + money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? T.strings.add : T.strings.soldOut;
      if (v.featured_media && $(`[data-slide][data-media-id="${v.featured_media.id}"]`, root)) showSlide(v.featured_media.id);
    };
    form.addEventListener('change', (e) => { if (e.target.closest('[data-option-group]')) update(); });

    const note = $('[data-gift-note]', form), count = $('[data-gift-count]', form);
    note && note.addEventListener('input', () => { count.textContent = `${note.value.length}/${note.maxLength}`; });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      const err = $('[data-form-error]', form); if (err) err.textContent = '';
      btn.disabled = true; btn.classList.add('is-loading');
      try {
        const res = await fetch(`${T.routes.add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag.');
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        await refreshDrawer(); openDrawer();
      } catch (x) { if (err) err.textContent = x.message; }
      finally { btn.disabled = false; btn.classList.remove('is-loading'); }
    });
  };

  /* ---------- recommendations ---------- */
  const initRecommendations = (el) => {
    fetch(el.dataset.url).then((r) => r.text()).then((html) => {
      const fresh = $('[data-recommendations]', new DOMParser().parseFromString(html, 'text/html'));
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  };

  /* ---------- global events ---------- */
  document.addEventListener('click', async (e) => {
    const menuBtn = e.target.closest('[data-menu-toggle]');
    if (menuBtn) { toggle(menuBtn, $('[data-mobile-nav]')); return; }
    const searchBtn = e.target.closest('[data-search-toggle]');
    if (searchBtn) { toggle(searchBtn, $('[data-search-panel]')); return; }
    const cartBtn = e.target.closest('[data-cart-open]');
    if (cartBtn && T.cartType === 'drawer' && document.body.dataset.template !== 'cart') {
      e.preventDefault(); await refreshDrawer(); openDrawer(); return;
    }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    const chg = e.target.closest('[data-cart-change]');
    if (chg) {
      chg.disabled = true;
      try {
        await fetch(`${T.routes.change}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: +chg.dataset.line, quantity: +chg.dataset.qty })
        });
        if (document.body.dataset.template === 'cart') window.location.reload(); else await refreshDrawer();
      } catch (x) { chg.disabled = false; }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer();
    toggle($('[data-menu-toggle]'), $('[data-mobile-nav]'), false);
    toggle($('[data-search-toggle]'), $('[data-search-panel]'), false);
  });

  /* ---------- compact header on scroll ---------- */
  const hdr = $('[data-header]');
  if (hdr) {
    let tick = false;
    const onScroll = () => { if (tick) return; tick = true; requestAnimationFrame(() => { hdr.classList.toggle('is-scrolled', window.scrollY > 40); tick = false; }); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- quick add (product cards) ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    const b = $('button', f); if (b.disabled) return;
    const label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    try {
      const res = await fetch(`${T.routes.add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add to cart.');
      if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
      await refreshDrawer(); openDrawer();
      b.textContent = 'Added ✓';
    } catch (x) { b.textContent = 'Try again'; }
    setTimeout(() => { b.textContent = label; b.disabled = false; }, 1600);
  });

  /* ---------- collection filters ---------- */
  const filters = $('[data-filters]');
  if (filters) {
    let t;
    filters.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => filters.submit(), 250); });
    filters.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-price-pill]'); if (!pill) return;
      const min = $('[data-price-min]', filters), max = $('[data-price-max]', filters);
      min.value = pill.dataset.min; max.value = pill.dataset.max;
      min.disabled = !min.value; max.disabled = !max.value;
      filters.submit();
    });
  }

  const ready = () => {
    $$('[data-product]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ready) : ready();

  /* theme editor: re-init on section reload */
  document.addEventListener('shopify:section:load', ready);
})();
